import { render } from "./CheckSickLeave.vue?vue&type=template&id=06027832&scoped=true"
import script from "./CheckSickLeave.vue?vue&type=script&lang=js"
export * from "./CheckSickLeave.vue?vue&type=script&lang=js"

import "./CheckSickLeave.vue?vue&type=style&index=0&id=06027832&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06027832"]])

export default __exports__